//src/pages/HomePage.js
import React, { lazy, Suspense } from "react";
import { useEffect, useState } from "react";
import EntryModal from "../components/EntryModal";
import TopBanner from "../components/TopBanner";
import MainHeader from "../components/MainHeader";
import CategoryCards from "../components/CategoryCards";
import SaleBanner from "../components/SaleBanner";
import CategoryHero from "../components/CategoryHero";
import FeaturedCategories from "../components/FeaturedCategories";
import CategoryCarousel from "../components/CategoryCarousel";
import Footer from "../components/Footer";
import HomeReviewsSection from "../components/HomeReviewsSection";
import ScrollingTicker from "../components/ScrollingTicker";
import CartDrawer from "../components/CartDrawer";
import AddedToBagToast from "../components/AddedToBagToast";
import { useSeo } from "../hooks/useSeo";

const AccessoriesSection = lazy(() =>
  import("../components/AccessoriesSection")
);

const FlatsMiniSection = lazy(() =>
  import("../components/FlatsMiniSection")
);

const LuxuryVideoShowcase = lazy(() =>
  import("../components/LuxuryVideoShowcase")
);


function HomePage() {
  useSeo("home", null, {
  "@context": "https://schema.org",
  "@graph": [
    {
      "@type": "Organization",
      "@id": `${window.location.origin}/#organization`,
      name: "Esiell",
      url: window.location.origin,
      logo: `${window.location.origin}/logo512-v2.png`,
      image: `${window.location.origin}/logo512-v2.png`,
      sameAs: [
        "https://www.instagram.com/esiell",
        "https://www.facebook.com/esiell"
      ]
    },
    {
      "@type": "WebSite",
      "@id": `${window.location.origin}/#website`,
      url: window.location.origin,
      name: "Esiell | Luxury Italian Shoes & Bags in Lebanon",
      publisher: {
        "@id": `${window.location.origin}/#organization`
      },
      potentialAction: {
        "@type": "SearchAction",
        target: `${window.location.origin}/products?search={search_term_string}`,
        "query-input": "required name=search_term_string"
      }
    }
  ]
});


  const [showEntry, setShowEntry] = useState(false);

useEffect(() => {
  const forceLogin = localStorage.getItem("esill-open-login");

  if (forceLogin) {
    setShowEntry(true);
  }
}, []);

useEffect(() => {
  const openEntry = () => setShowEntry(true);
  window.addEventListener("open-entry-modal", openEntry);
  return () => window.removeEventListener("open-entry-modal", openEntry);
}, []);


const closeEntry = () => {
  localStorage.removeItem("esill-open-login"); // 👈 important
  setShowEntry(false);
};



  return (
    <div className="w-full bg-white min-h-screen flex flex-col overflow-x-hidden">

      <TopBanner />
      <MainHeader
        onMenuOpen={() => console.log("Menu drawer opens")}
        onSearchOpen={() => console.log("Search opens")}
        onBagOpen={() => console.log("Bag page")}
      />
      <CartDrawer />
      <AddedToBagToast />
      <CategoryCards />
      <SaleBanner />
      <CategoryCarousel />
      <CategoryHero />

      <FeaturedCategories />

<Suspense fallback={null}>
  <AccessoriesSection />
  <FlatsMiniSection />
  <LuxuryVideoShowcase />
</Suspense>

<ScrollingTicker />
<HomeReviewsSection />
      <Footer className="mt-auto" />
      <EntryModal isOpen={showEntry} onClose={closeEntry} />
    </div>
  );
}

export default HomePage;
